export default function LabelChecklist(props) { 
    return (
        <h5>{props.label}</h5>
    )
}
